export const getCampaigns = (experiences) => {
  if (!experiences) {
    return [];
  }
  return experiences
    .filter((experience) => !experience.impressionId)
    .map((experience, i) => ({
      ...(experience.impressionId && { id: experience.impressionId }),
      key: experience.experienceName,
      reports: [],
      split: experience.variantLabel,
      parameters: experience.parameters,
      variant_id: i + 1,
    }));
};

export const getExperiences = (experiences, experienceName) => {
  if (!experiences) {
    return [];
  }

  const filteredExperiences = experiences.filter((exp) => {
    if (exp?.parameters?.contentFeatureFlag) {
      return exp.experienceName;
    }
    return exp.experienceName.startsWith(experienceName);
  });

  return filteredExperiences;
};

export const setPageType = (type) => {
  if (type) {
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(['setPageType', type]);
    window.monetateQ.push(['trackData']);
  }
};

export const dispatchMonetateQEvent = (eventName) => {
  window.monetateQ = window.monetateQ || [];
  window.monetateQ.push(['trackEvent', [eventName]]);
};
